import React, { useState } from 'react';

function ModalExtraction({ API_URL, token, onFermer, onAjouter }) {
    const [contenu, setContenu] = useState('Analyse en cours...');
    const [loading, setLoading] = useState(false);

    async function traiterFichier(event) {
        const fichier = event.target.files[0];
        if (!fichier) return;
        setLoading(true);
        setContenu('🔄 Analyse du document en cours...');

        const base64 = await new Promise((resolve, reject) => {
            const reader   = new FileReader();
            reader.onload  = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(fichier);
        });

        try {
            const res  = await fetch(`${API_URL}/extraire-document`, {
                method : 'POST',
                headers: { 
                            Authorization: `Bearer ${token}`, 
                            'Content-Type': 'application/json',
                            "ngrok-skip-browser-warning": "true"
                        },
                body   : JSON.stringify({
                    fichier_base64: base64,
                    media_type    : fichier.type,
                    nom_fichier   : fichier.name
                })
            });
            const data = await res.json();
            setContenu(data.extraction);
        } catch(e) {
            setContenu('Erreur lors de l\'analyse du document.');
        }
        setLoading(false);
        event.target.value = '';
    }

    return (
        <div
            onClick = {e => e.target === e.currentTarget && onFermer()}
            style={{
                display: 'flex', position: 'fixed', inset: 0,
                background: 'rgba(0,0,0,0.6)', zIndex: 100,
                alignItems: 'center', justifyContent: 'center'
            }}
        >
            <div style={{
                background: 'var(--bg-light)', border: '1px solid var(--border)',
                padding: '32px', borderRadius: '12px',
                width: '480px', maxWidth: '90vw',
                maxHeight: '80vh', overflowY: 'auto'
            }}>
                <h3 style={{ fontSize: '16px', fontWeight: 500, color: 'var(--white)', marginBottom: '16px' }}>
                    📄 Données extraites du document
                </h3>

                {/* Zone upload */}
                <div
                    onClick = {() => document.getElementById('file-input-extraction').click()}
                    style={{
                        border       : '1px dashed var(--border)',
                        borderRadius : '8px',
                        padding      : '20px',
                        textAlign    : 'center',
                        cursor       : 'pointer',
                        color        : 'var(--text-muted)',
                        fontSize     : '13px',
                        marginBottom : '16px',
                        transition   : 'border-color 0.2s'
                    }}
                    onMouseOver = {e => e.currentTarget.style.borderColor = '#555'}
                    onMouseOut  = {e => e.currentTarget.style.borderColor = 'var(--border)'}
                >
                    <div style={{ fontSize: '24px', marginBottom: '8px' }}>📎</div>
                    <div style={{ color: 'var(--text)', fontWeight: 500, marginBottom: '4px' }}>
                        Cliquer pour choisir un fichier
                    </div>
                    <div style={{ fontSize: '12px' }}>PDF ou image</div>
                </div>

                <input
                    id       = "file-input-extraction"
                    type     = "file"
                    accept   = ".pdf,image/*"
                    onChange = {traiterFichier}
                    style    = {{ display: 'none' }}
                />

                {/* Contenu extrait */}
                <div style={{
                    background: 'var(--bg)', border: '1px solid var(--border)',
                    borderRadius: '8px', padding: '16px',
                    fontSize: '13px', color: 'var(--text)',
                    lineHeight: 1.65, marginBottom: '20px',
                    whiteSpace: 'pre-wrap', maxHeight: '300px',
                    overflowY: 'auto'
                }}>
                    {contenu}
                </div>

                {/* Boutons */}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick = {onFermer}
                        style={{
                            padding: '9px 18px', background: 'transparent',
                            border: '1px solid var(--border)', borderRadius: '8px',
                            color: 'var(--text-muted)', fontSize: '13px', cursor: 'pointer'
                        }}
                    >Annuler</button>
                    <button
                        onClick  = {() => onAjouter(contenu)}
                        disabled = {loading}
                        style={{
                            padding: '9px 18px', background: 'var(--white)',
                            color: '#1a1a1a', border: 'none',
                            borderRadius: '8px', fontSize: '13px',
                            fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.5 : 1
                        }}
                    >Ajouter à la consultation</button>
                </div>
            </div>
        </div>
    );
}

export default ModalExtraction;